import { getAssetBaseUrl } from '../../utils';
import { ICON_COLOR } from '../Icon.colors';
import { IIcon } from '../IIconAssetMap';

const light: string = `${getAssetBaseUrl()}/magnifying_glass_light.svg`;
const dark: string = `${getAssetBaseUrl()}/magnifying_glass_dark.svg`;

export const magnifyingGlass: IIcon = {
    [ICON_COLOR.DARK]: dark,
    [ICON_COLOR.LIGHT]: light,
    DEFAULT: light,
};
